import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        <h1 className="footer__title">Arghya</h1>

        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>
          <li>
            <a href="#portfolio" className="footer__link">
              Projects
            </a>
          </li>
        </ul>
        <div className="footer__social">
          <a
            href="https://github.com/arghyadeb11"
            className="home__social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="uil uil-github"></i>
          </a>
          <a
            href="https://wa.me/+918902429351"
            className="home__social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="uil uil-whatsapp"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
